import { GET_VOYAGE_DATA,IS_PAST_VOYAGE,PAST_VOYAGE_LIST} from './../constants/actionTypes'
const voyage = (store = {}, action = {}) => {
  switch (action.type) {
    case GET_VOYAGE_DATA:
      return action.data
    default:
      return store
  }
}
const isPastVoyage = (store = false, action = {}) => {
  switch (action.type) {
    case IS_PAST_VOYAGE:
      return action.data
    default:
      return store
  }
}
const pastVoyageList = (store = [], action = {}) => {
  switch (action.type) {
    case PAST_VOYAGE_LIST:
    return [
      ...store,
      ...action.data 
    ]
    default:
      return store
  }
}
export {isPastVoyage,voyage,pastVoyageList}
